export default __webpack_public_path__ + "meteor.8f338f46.png";